import { render, staticRenderFns } from "./RegistrationTagBadge.vue?vue&type=template&id=0c479fba&scoped=true&"
import script from "./RegistrationTagBadge.vue?vue&type=script&lang=js&"
export * from "./RegistrationTagBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c479fba",
  null
  
)

export default component.exports